export default "__VITE_ASSET__pRPP3lMF__"